import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const VideoContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  marginY: theme.spacing(2),
}));

export const VideoWrapper = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: '100%',
  paddingTop: '56.25%', // 16:9 aspect ratio
  overflow: 'hidden',
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[2],
}));

export const VideoIframe = styled('iframe')({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  border: 'none',
}); 